import axios from 'axios'
import { Message, MessageBox } from 'element-ui';

// 通过获取访问地址的方式设置生产环境请求地址
// const root =  process.env.NODE_ENV === "development"?process.env.API_ROOT:window.location.host

// 创建实例 
const http = axios.create({
    // baseURL: root,
    timeout: 25000, //请求时间
    responseType: 'json',
    withCredentials: false, // 表示跨域请求时是否需要使用凭证
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        'Access-Control-Allow-Origin': '*'
    }
})

// 请求拦截
http.interceptors.request.use(config=>{
    if(config.url.indexOf('/aboutus/news/find?access_token') == -1 && config.url.indexOf('/trial/add?access_token') == -1){
        const params = new URLSearchParams();
        if(config.url.indexOf('/oauth/token') !== -1 ){
            params.append('grant_type', 'password');
            params.append('client_id', 'system');
            params.append('client_secret', 'secret');
            params.append('username', 'mtadn');
            params.append('password', '9yo+vEiMeYCiHNIJ2SGnfQ==');
            params.append('role', 'ADMIN');
        }else{
            params.append('access_token', localStorage.getItem('token'));
            params.append('language',  localStorage.getItem('lang'));
            if(config.url.indexOf('/aboutus/news/find_one') !== -1){
                params.append('id', config.data.id);
            }
        }
        config.data = params
    }else{
        console.log(config)
        config.headers['Content-Type'] = "application/json; charset=utf-8"
    }
    //请求前统一添加
    return config
},err=>{
    // 请求错误统一处理
    return Promise.reject(err)
})

// 响应拦截
http.interceptors.response.use(response=>{
    if(response.config.url.indexOf('/oauth/token') !== -1){
        return response.data
    }else{
        // 响应数据统一处理
        if(response.data.code == 0){
            return response.data.data
        }else{
            console.log(response.message)
        }
    }
},error=>{
    if (error.response) {
        switch (error.response.status) {
            case 400:
                Message({
                    message: '请求出错',
                    type: 'error'
                });
            break;
            case 401:
                // MessageBox.confirm('用户无访问权限, 刷新页面后继续访问', '无访问权限', {
                //     confirmButtonText: '刷新页面',
                //     showCancelButton: false,
                //     type: 'warning'
                // }).then(() => {
                    // 清除token的代码
                    localStorage.clear()
                    location.reload();
                // })
                break;
            case 403:
                Message({
                    message: '拒绝访问',
                    type: 'error'
                });
                break;
            case 404:
                Message({
                    message: '请求出错',
                    type: 'error'
                });
                break;
            case 408:
                Message({
                    message: '请求超时',
                    type: 'error'
                });
                break;
            case 500:
                Message({
                    message: '服务器内部错误',
                    type: 'error'
                });
                break;
            case 502:
                Message({
                    message: '网络错误',
                    type: 'error'
                });
            case 503:
                Message({
                    message: '服务器不可用',
                    type: 'error'
                });
                break;
            case 504:
                Message({
                    message: '网络超时',
                    type: 'error'
                });
                break;
            case 505:
                Message({
                    message: 'HTTP版本不支持',
                    type: 'error'
                });
                break;
            //其他错误，直接抛出
            default:
                Message({
                    message: error.response.data.message,
                    type: 'error'
                });
        }
        return Promise.reject(error.response.data);
    } else {
        Message({
            message: "连接服务器失败",
            type: 'error'
        });
    }
})

export default http


// WEBPACK FOOTER //
// ./src/axios.js